// eslint-disable-next-line
export default {
  GetToken() {
    return `/customer/signin`;
  },

  Login() {
    return `/customer/signin`;
  },
  Register() {
    return `/customer/register`;
  },
  RegisterV2() {
    return `/customer/registerv2`;
  },
  UpdateUserProfileV2() {
    return `/customer/updateprofilev2`;
  },
  UpdateUserEmailV2() {
    return `/customer/updateemailv2`;
  },
  RouteFarePrices(departId, destId) {
    return `/Fares/GetRouteFares/departureTerminalId/destinationTerminalId?departureTerminalId=${departId}&destinationTerminalId=${destId}`;
  },
  DepartureTerminals() {
    // return `/Terminal?AvialableOnLine=1000&Paginated=false`;
    return `/Terminal/DepartureTerminalsByCountryCode/GH`;
  },
  ArrivalTerminals(departureTerminalId) {
    return `/Terminal/GetDestinationTerminals/${departureTerminalId}`;
    // return `/Terminal/GetDepartureTerminals?destinationTerminalId=${departureTerminalId}&countryCode=ng`;
  },
  BookingSearch() {
    return `/Booking/availabletripdetails`;
  },
  PostSearch() {
    return `/booking`;
  },
  InitiateCreditDirectRequest(refCode) {
    return `/Payment/InitiateCreditDirectRequest/${refCode}`;
  },
  InitiateMoniePointRequest() {
    return `/api/v1/Moniepoint/initialize`;
  },
  ConfirmMoniePointPayment(refCode) {
    return `/api/v1/Moniepoint/processMoniepointPayment/${refCode}/NGN`;
  },
  InitiatePaystackNewPayRequest() {
    return `/api/v1/Paystack/initialize`;
  },
  InitiateNombaRequest() {
    return `/api/v1/Nomba/initialize`;
  },
  ConfirmNombaPayment(refCode) {
    return `/api/v1/Nomba/processNombaPayment/${refCode}`;
  },
  HireSearchOneway(
    OnewayPickupDate,
    OnewayDistanceApart,
    OneWayDropoffLocation,
    OnewayPickupLocation
  ) {
    return `/HireBooking/bookingSearch?OnewayPickupDate=${OnewayPickupDate}&OnewayDistanceApart=${OnewayDistanceApart}&OneWayDropoffLocation=${OneWayDropoffLocation}&HiredServiceType=0&OnewayPickupLocation=${OnewayPickupLocation}&IsSleepOver=false`;
    // return `/api/hiredServiceBookings/hireservicebookingsearch`;
  },
  HireSearch(
    OnewayPickupDate,
    OnewayDistanceApart,
    OneWayDropoffLocation,
    OnewayPickupLocation,
    ReturnPickupDate = null,
    ReturnPickupLocation = null,
    ReturnDropoffLocation = null,
    IsSleepOver = false
  ) {
    return `/HireBooking/bookingSearch?OnewayPickupDate=${OnewayPickupDate}&OnewayDistanceApart=${OnewayDistanceApart}&OneWayDropoffLocation=${OneWayDropoffLocation}&HiredServiceType=1&OnewayPickupLocation=${OnewayPickupLocation}&IsSleepOver=${IsSleepOver}&ReturnPickupDate=${ReturnPickupDate}&ReturnPickupLocation=${ReturnPickupLocation}&ReturnDropoffLocation=${ReturnDropoffLocation}`;
    // return `/api/hiredServiceBookings/hireservicebookingsearch`;
  },
  HireServiceSearch() {
    return `/HireBooking/requestBooking`;
  },
  ConfirmPayStackPayment(refCode) {
    return `/Payment/ProcessPaystackPayment/${refCode}/GH`;
  },
  ConfirmFlutterPayment(refCode) {
    return `/Payment/ProcessFlutterWavePayment/${refCode}`;
  },
  ConfirmBudPayPayment(refCode) {
    return `/Payment/ProcessBudPayPayment/${refCode}`;
  },
  ConfirmAzaPayPayment() {
    return `/api/Webhook/ValidateAzaPayTransaction`;
  },
  ConfirmHirePayStackPayment(refCode) {
    return `/Payment/ProcessHiredServicePaystackPayment/${refCode}`;
  },
  ForgotPassword() {
    return `/api/customers/ForgotPasswordVerificationCode`;
  },
  ResetPassword() {
    return `/customer/forgetpasswordv2`;
  },
  SendOtp() {
    return `/customer/sendotp`;
  },
  SendOtpToPhone() {
    return `/Otp/sendtophonenumber`;
  },
  SendOtpToEmail() {
    return `/Otp/sendtoemail`;
  },
  VerifyOtp() {
    return `/customer/verifyotp`;
  },
  CustomerVerifyOtp() {
    return `/Otp/verify`;
  },
  UpdatePhoto() {
    return `/customer/updatephoto`;
  },
  UpdatePassegerProfile() {
    return `/customer/Update`;
  },
  DeletePhoto(customerId) {
    return `/api/customers/removeCustomerPhoto/${customerId}`;
  },
  GetWalletToken() {
    return `/connect/token`;
  },
  CreateWallet() {
    return `/api/WalletApi/CreateWallet`;
    // return `/api/v3/WalletApi/CreateWallet?walletType=3`;
  },
  GetWallet(phone, email) {
    return `/api/WalletApi/GetUserWallet?phone=${phone}&email=${email}`;
    // return `/api/v3/WalletApi/GetUserWallet/${phone}/${email}`;
  },
  CreatePartnerStellersAcct() {
    return `/api/v3/WalletApi/UpdateBankRequirement`;
  },
  GenerateOtp() {
    return `/api/v2/WalletApi/GenerateOtp`;
  },
  CreatePin() {
    return `/api/WalletApi/CreatePin`;
  },
  CreatePayment() {
    return `/api/PaymentApi/CreatePayment`;
  },
  VerifyPayStackRef(paystackreference) {
    return `/api/PaymentApi/VerifyPaystackRef?paymentreference=${paystackreference}`;
  },
  DebitWallet() {
    return `/api/WalletApi/DebitWallet`;
  },
  BookingHistory(email) {
    return `/CustomerBooking/bookingHistorys?Email=${email}&CountryCode=NG&Paginated=false`;
  },
  ChangePassword() {
    return `/customer/ChangePassword`;
  },

  ChangeWalletpin() {
    return `/api/WalletApi/ChangePin`;
  },
  ResetWalletpin() {
    return `/api/WalletApi/ResetPin`;
  },
  Updatecustomerstageafterwalletsetup(phone, email) {
    return `/Customer/updatecustomerstageafterwalletsetup/${phone}/${email}`;
  },
  CustomerFeedback() {
    return `/api/CustomerFeedbacks`;
  },
  BookingStatus(refCode) {
    return `/Booking/limited?BookingRefCode=${refCode}`;
  },
  SuggestRoute() {
    return `/route/addnewsuggestedroute`;
  },
  GetpopularRoute() {
    return `/Route/getpopularroutes?noOfDays=5&noOfRoutes=5`;
  },
  TrackVehicleById(imei) {
    return `/AutoTrack/vehicletrip?vehicleImei=${imei}`;
  },
  SavePartnerEnquiry() {
    return `/PartnerEnquiry`;
  },
  GetTerminalById(terminalId) {
    return `/terminal/${terminalId}`;
  },
  GetAllPaymentGateways() {
    return `/api/v1/PaymentGateway?PageNumber=1&PageSize=20`;
  },
  GetAllPaymentGatewaysById(id) {
    return `/api/v1/PaymentGateway/Gateways/${id}?countryCode=GH`;
  },
  CheckPassengerIn(refCode, terminalId) {
    return `/SeatManagement/getseatSelf/refcode/${refCode}/${terminalId}`;
  },
  ProcessWallet() {
    return `/Payment/ProcessWalletPayment`;
  },
  GetDistance(departureAddress, arrivalAddress) {
    return `/HireBooking/getDistance?depart=${departureAddress}&arrival=${arrivalAddress}`;
    // return `/api/booking/hiredbookings/getDistance?depart=${departureAddress}&arrival=${arrivalAddress}`;
  },
  GetDistanceByPlaceId(departureAddress, arrivalAddress) {
    return `/api/Google/getdistancewithplaceid?origin=${departureAddress}&destination=${arrivalAddress}`;
  },
  GetLocationForUser(input, sessionToken) {
    return `/api/Google/autocomplete?input=${input}&sessionToken=${sessionToken}`;
  },
  GetLocationPlaceIdDetails(placeId, sessionToken) {
    return `/api/Google/placedetails?placeId=${placeId}&sessionToken=${sessionToken}`;
  },
  GetNewToken() {
    return `/Customer/generatenewtoken`;
  },
};
